"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddTokenInput = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var AddTokenInput = (function (_super) {
    __extends(AddTokenInput, _super);
    function AddTokenInput(props) {
        var _this = _super.call(this, props) || this;
        _this.tokenName = "";
        _this.errorMessage = "";
        _this.addButtonState = kaleidoscope_1.ButtonState.Idle;
        _this.buttonDisabled = false;
        _this.validInput = new RegExp(/^[a-zA-Z0-9_ ]*$/);
        _this.onTokenInputKeyDown = function (event) {
            if (event.key === "Enter" && !_this.isAddButtonDisabled && _this.addButtonState !== kaleidoscope_1.ButtonState.Waiting) {
                _this.onAddToken();
            }
        };
        _this.onAddToken = function () { return __awaiter(_this, void 0, Promise, function () {
            var result, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.showWaitingState();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.props.onAddToken(this.tokenName)];
                    case 2:
                        result = _a.sent();
                        return [3, 4];
                    case 3:
                        e_1 = _a.sent();
                        result = {
                            isError: true,
                            errorMessage: "Something went wrong. Please try again.",
                        };
                        return [3, 4];
                    case 4:
                        if (this.isAddTokenError(result)) {
                            this.showErrorState(result.errorMessage);
                        }
                        else {
                            this.showSuccessState();
                        }
                        return [2];
                }
            });
        }); };
        return _this;
    }
    Object.defineProperty(AddTokenInput.prototype, "isAddButtonDisabled", {
        get: function () {
            return this.tokenName.length === 0 || this.buttonDisabled;
        },
        enumerable: false,
        configurable: true
    });
    AddTokenInput.prototype.setButtonDisabled = function (isDisabled) {
        this.buttonDisabled = isDisabled;
    };
    AddTokenInput.prototype.setErrorMessage = function (errorMessage) {
        this.errorMessage = errorMessage;
    };
    AddTokenInput.prototype.clearErrorMessage = function () {
        this.errorMessage = "";
    };
    AddTokenInput.prototype.setAddButtonState = function (buttonState) {
        this.addButtonState = buttonState;
    };
    AddTokenInput.prototype.showWaitingState = function () {
        this.clearErrorMessage();
        this.setAddButtonState(kaleidoscope_1.ButtonState.Waiting);
    };
    AddTokenInput.prototype.showSuccessState = function () {
        var _this = this;
        this.clearErrorMessage();
        this.setAddButtonState(kaleidoscope_1.ButtonState.Success);
        setTimeout(function () {
            if (_this.addButtonState === kaleidoscope_1.ButtonState.Success) {
                _this.setAddButtonState(kaleidoscope_1.ButtonState.Idle);
            }
        }, 3500);
    };
    AddTokenInput.prototype.showErrorState = function (errorMessage) {
        this.setErrorMessage(errorMessage);
        this.setAddButtonState(kaleidoscope_1.ButtonState.Idle);
    };
    AddTokenInput.prototype.onTokenNameChange = function (tokenName) {
        this.tokenName = tokenName;
        if (this.validInput.test(tokenName)) {
            this.clearErrorMessage();
            this.setButtonDisabled(false);
        }
        else {
            this.setButtonDisabled(true);
            this.showErrorState("You can use only alphanumeric characters, underscores and spaces");
        }
    };
    AddTokenInput.prototype.render = function () {
        var _a = this.props, className = _a.className, label = _a.label, placeholder = _a.placeholder, maxTokenLength = _a.maxTokenLength;
        return (react_1.default.createElement(kaleidoscope_1.TextInput, { className: className, label: label !== null && label !== void 0 ? label : "", placeholder: placeholder, maxLength: maxTokenLength, error: this.errorMessage, endElement: this.renderAddButton(), onChange: this.onTokenNameChange, onKeyDown: this.onTokenInputKeyDown }));
    };
    AddTokenInput.prototype.renderAddButton = function () {
        return (react_1.default.createElement(kaleidoscope_1.Button, { size: kaleidoscope_1.ButtonSize.Small, buttonState: this.addButtonState, disabled: this.isAddButtonDisabled, onClick: this.onAddToken }, "Add"));
    };
    AddTokenInput.prototype.isAddTokenError = function (result) {
        return !!result.isError;
    };
    var _a;
    AddTokenInput.defaultProps = {
        label: "Add a token",
        placeholder: "E.g Token name",
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], AddTokenInput.prototype, "tokenName", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], AddTokenInput.prototype, "errorMessage", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], AddTokenInput.prototype, "addButtonState", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], AddTokenInput.prototype, "buttonDisabled", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], AddTokenInput.prototype, "isAddButtonDisabled", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], AddTokenInput.prototype, "setButtonDisabled", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], AddTokenInput.prototype, "setErrorMessage", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AddTokenInput.prototype, "clearErrorMessage", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof kaleidoscope_1.ButtonState !== "undefined" && kaleidoscope_1.ButtonState) === "function" ? _a : Object]),
        __metadata("design:returntype", void 0)
    ], AddTokenInput.prototype, "setAddButtonState", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AddTokenInput.prototype, "showWaitingState", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AddTokenInput.prototype, "showSuccessState", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], AddTokenInput.prototype, "showErrorState", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], AddTokenInput.prototype, "onTokenNameChange", null);
    AddTokenInput = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], AddTokenInput);
    return AddTokenInput;
}(react_1.default.Component));
exports.AddTokenInput = AddTokenInput;
